export const formatCurrency = (value) => {
  return Number(value || 0).toLocaleString('en-AU', {
    style: 'currency',
    currency: 'AUD'
  });
};

export const convertToHours = (minutes) => {
  const num = Number(minutes);
  if (!Number.isFinite(num) || num <= 0) return '0.00';
  return (num / 60).toFixed(2);
};
export const parseCurrency = (val) => {
  if (typeof val === 'string') {
    return parseFloat(val.replace(/[^0-9.-]+/g, '')) || 0;
  }
  return typeof val === 'number' ? val : 0;
};

export const formatDateForDisplay = (d) => {
  if (!d) return '—';
  const dt = new Date(d);
  return dt.toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const displayDateFormat = (isoDate) => {
  if (!isoDate) return '';
  const [year, month, day] = isoDate.split('-');
  return `${day}/${month}/${year}`;
};